// extracted by mini-css-extract-plugin
export default {"modalOverlay":"CD-z","modalContent":"DD-z","header":"ED-z","close":"FD-z"};